<div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" role="switch" [id]="id" [checked]="checked"
    (change)="onChanged($event)" (blur)="onBlur($event)" [disabled]="disabled">
  <label class="form-check-label" [for]="id">
    @if (!hasLabel()) {
      <ng-content></ng-content>
    }
    @if (hasLabel()) {
      {{ getLabel() }}
    }
  </label>
</div>
